import React, { useRef, useState } from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import { format } from 'date-fns';

import { ArrowRightTan } from '@assets/icons';
import { ListingPicker } from '@components/_shared/datePickers/listingPicker';
import { useClickOutside } from '@utils/hooks/useClickOutside';
import { ListingType } from '@utils/types/listing';
import { BaseInputProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

type TData = Record<string, any> & {
  check_in: Date | null;
  check_out: Date | null;
};

type Props = {
  data: TData;
  setData: (data: TData) => void;
  disabledDates: string[];
  minNightsStay?: number;
  maxNightsStay?: number;
  firstAvailableDate?: ListingType['first_available_date'];
  lastKnownDay?: ListingType['last_known_date'] | null;
} & BaseInputProps;

export function DatesInputWithListingCalendar(props: Props) {
  const {
    data,
    setData,
    disabledDates,
    minNightsStay,
    maxNightsStay,
    firstAvailableDate,
    lastKnownDay,
  } = props;
  const [showCalendar, setShowCalendar] = useState(false);

  const datesRef = useRef<HTMLDivElement>(null);
  useClickOutside(datesRef, () => setShowCalendar(false));

  const toggleCalendar = () => {
    setShowCalendar((prev) => !prev);
  };
  return (
    <div ref={datesRef} className={styles.datesInputContainer}>
      <div className={styles.datesInput} onClick={toggleCalendar}>
        <div>
          {data.check_in ? format(data.check_in, 'MMM dd') : 'Check-Out'}
        </div>

        <ArrowRightTan />

        <div>
          {data.check_out ? format(data.check_out, 'MMM dd') : 'Check-In'}
        </div>
      </div>

      {showCalendar && (
        <ListingPicker
          value={{
            from: data.check_in,
            to: data.check_out,
          }}
          onDatesChange={(range) => {
            if (range.from && range.to) {
              toggleCalendar();
            }
            setData({
              ...data,
              check_in: range.from,
              check_out: range.to,
            });
          }}
          onClearDates={
            data.check_in && data.check_out
              ? () => {
                  setData({
                    ...data,
                    check_in: null,
                    check_out: null,
                  });
                }
              : undefined
          }
          disabledDates={disabledDates}
          minNightsStay={minNightsStay}
          maxNightsStay={maxNightsStay}
          firstAvailableDate={firstAvailableDate}
          lastKnownDay={lastKnownDay}
          withUpsellSuggestions={false}
          containerStyle={styles.calendarContainer}
        />
      )}
    </div>
  );
}
